define('utils/sigfox-commons',['jquery', 'utils/form', 'commons/message-manager', 'commons/popup-dialog', 'utils/application-data', 'commons/password-change', 'commons/floating-panel', 'jquery.ui', 'chosen', 'jquery-cookie'],
        function($, form, messages, PopupDialog, applicationData, passwordChange, FloatingPanel) {

    $.each([{
        id: '#feedbackError',
        fn: 'error'
    }, {
        id: '#feedbackWarn',
        fn: 'warn'
    }, {
        id: '#feedbackInfo',
        fn: 'info'
    }],function(index, item) {
        var dataField = $(item.id).text();
        if (dataField.length > 0) {
            messages[item.fn](dataField);
        }
    });

    $('form').submit(function() {
        if (form.isDisabledOnSubmit(this)) {
            return false;
        }
        form.disableOnSubmit(this);
        return true;
    });
    
    // Global ajax error behavior
    $(document).ajaxError(function(event, jqXHR) {
        var redirectLocation = jqXHR.getResponseHeader('location');
        if (redirectLocation) {
            location.href = redirectLocation;
        } else if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
            messages.error(jqXHR.responseJSON.error);
        } else if(jqXHR.responseText && jqXHR.responseText.length > 0) {
            try {
               var json = jQuery.parseJSON(jqXHR.responseText);
               if(json.error) {
                   messages.error(json.error);
               }
            } catch (e) {
                // Nothing to do
            }
        }
    });

    // Show or hide the "go to top" button
    var goToTop = $('#go-to-top');
    $(window).scroll(function() {
        if ($(this).scrollTop() > 0) {
            goToTop.fadeIn(200);
        } else {
            goToTop.fadeOut(200);
        }
    });

    // go to top
    goToTop.click(function(event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'fast');
    });

    $(document).tooltip({
        items: ':not(.no-tooltip *)' //Only browser tooltip will be displayed in case of Jquery incompatibilities with event framework
    });

    var eulaOptions = {
        popupTitle: 'Terms and conditions of use (TCU)',
        popupLinks: '.eula-info',
        height: 600
    };
    var fullOption = $.extend({}, eulaOptions);
    if (!applicationData.eula) {
        $.extend(fullOption, {
            modal: true,
            closeOnEscape: false,
            displayClose: false,
            buttons: [{
                text: 'Accept',
                click: function() {
                    $.ajax({
                        type: 'POST',
                        url: '/user/eula',
                        success: function(result) {
                            popupEula.popup.dialog('close');
                            popupEula.unbind();
                            popupEula = new PopupDialog('#footer', eulaOptions);
                        }
                    });
                }
            }, {
                text: 'Decline',
                click: function() {
                    window.location = '/auth/logout';
                }
            }]
        });
    }

    var popupEula = new PopupDialog('#footer', fullOption);

    if (!applicationData.eula) {
        popupEula.popup.dialog('open');
        popupEula.loadDataPopup('/user/frag/eula-info');
    }

    if (!applicationData.changePassword) {
        var popupChangePassword = new FloatingPanel({
            customClassSuffix: 'role-description',
            closeOnEscape: false,
            title: 'Password security enhancement measure',
            contentUrl: '/user/frag/change-password',
            onSuccess : function () {
                passwordChange();
                $("#change-password-form").submit(function(e) {
                    var postData = $(this).serializeArray();
                    var formURL = $(this).attr("action");
                    $.ajax({
                        url : formURL,
                        type: "POST",
                        data : postData,
                        success:function(data, textStatus, jqXHR) {
                            $("#form-errors").empty();
                            var errors = data.errors;
                            if (errors) {
                                for(var i in errors) {
                                    $("#form-errors").append("<p class='error'>" + errors[i]  + "</p>");
                                }
                            } else {
                                popupChangePassword.hide();
                                messages.info('Password successfully updated');
                            }
                        }
                    });
                    return false;
                });
            },
            height: 600
        });
        popupChangePassword.show();
    }

    $('select#operators:not(.ignore-chosen)').removeClass('hidden').chosen({
        disable_search_threshold: 7,
        allow_single_deselect: true,
        search_contains : true,
        no_results_text: 'Nothing found for '
    });
    
    $('.responsive-menu-title').on('click', function(e){
        e.stopPropagation();
        $('.responsive-menu').toggleClass('opened');
        $(document).one('click keyup', function(e){
            if(e.type == 'keyup' && e.keyCode !== 27){
                return ;
            }
            $('.responsive-menu').removeClass('opened');
        });
    });

    var showCookiePolicy = function(e) {
        e.preventDefault();
        var cpOptions = {
            popupTitle: 'Cookie Policy',
            popupLinks: '.cookie-policy-info',
            height: 600,
            modal: true,
            closeOnEscape: true,
            displayClose: true
        };

        var popupCp = new PopupDialog('#footer', cpOptions);

        popupCp.popup.dialog('open');
        popupCp.loadDataPopup('/user/frag/cookie-policy-info');

    };

    // If the cookie disclaimer is shown
    var cookieDisclaimer = $('#cookie-disclaimer');
    if (typeof cookieDisclaimer != null) {
        $('#cd-close-button').click(function(e) {
            e.preventDefault();
            cookieDisclaimer.fadeOut();
            $.ajax({
                method: 'POST',
                url: '/userPrefs/edit/has-seen-cookie-disclaimer',
            });
            return false;
        });
    }

    $('.cookie-policy-button').click(function(e) {
        showCookiePolicy(e);
        return false;
    });

    var deviceFingerprintCookieName = 'SIGFOX_DEVICE_FINGERPRINT';
    var deviceFingerprintCookieContent = $.cookie(deviceFingerprintCookieName);
    if (deviceFingerprintCookieContent === undefined || deviceFingerprintCookieContent === "") {
        var deviceFingerprint = "";
        if (typeof crypto !== "undefined" && typeof crypto.randomUUID !== "undefined") {
            deviceFingerprint = crypto.randomUUID();
        }
        if (deviceFingerprint === "") {
            deviceFingerprint = "compat-" + Math.random().toString(36).slice(-10);
        }
        $.cookie(deviceFingerprintCookieName, deviceFingerprint, { expires: 365, path: '/' });
    }

});

